import { render, staticRenderFns } from "./AuthorizationLayout.vue?vue&type=template&id=03120763&scoped=true"
import script from "./AuthorizationLayout.vue?vue&type=script&lang=js"
export * from "./AuthorizationLayout.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationLayout.vue?vue&type=style&index=0&id=03120763&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03120763",
  null
  
)

export default component.exports